<template>
  <span>
    <b-card no-body>
      <b-card-header>
        <b-row>
          <b-col md="10">
            <h3>Classificar Rede de Promoção</h3>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col cols="10">
            <b-form-group label="Categorias:" v-slot="{ ariaDescribedby }">
              <b-form-checkbox-group id="checkbox-group-1" v-model="tp_categorias" :aria-describedby="ariaDescribedby"
                name="flavour-1" class="m-1" stacked>
                    <b-form-checkbox v-for="item in categorias" :value="item.id" :key="item.id">
                      {{ item.nome }}
                    </b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="2">
            <b-button v-if="!loading" @click="importar" block variant="primary">
              <i class="fa fa-plus"></i>
              <span>Importar</span>
            </b-button>
            <b-button v-else variant="primary" class="btn btn-block" disabled>
              <b-spinner small type="grow"></b-spinner>Salvando...
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </span>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import miniToastr from 'mini-toastr'
import SessionStorage from '@/services/session-storage'

miniToastr.init()

export default {
  components: {
    Pagination
  },
  created () {
    if (SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') !== 'A') {
      this.$router.push('/')
    }
    this.$store.dispatch('buscarCategoriasRedes')
  },
  computed: {
    categorias () {
      return this.$store.state.categoriaRede.listaCategoriasRedes
    }
  },
  data () {
    return {
      resource: 'classifica-redes',
      totalPorPagina: 10,
      situacoes: [],
      loading: false,
      tp_categorias: []
    }
  },
  watch: {
    'categorias': function (value) {
      value.forEach(element => {
        if (element.situacao) {
          this.tp_categorias.push(element.id)
        }
      })
    }
  },
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    importar () {
      this.loading = true
      this.$bvModal.msgBoxConfirm('Confirma a importação das categorias selecionadas?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          const data = {
            tp_categorias: this.tp_categorias
          }
          Vue.http.post('api/classifica-redes', data).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
            }
            this.loading = false
          }).catch(() => {
            miniToastr.setIcon('error', 'i', { 'class': 'fa fa-check' })
            miniToastr.error('Falha na importação!', 'Alerta!', 7000)
            this.loading = false
          })
        }
      }).catch(erro => {
        if (!erro.body.success) {
          miniToastr.setIcon('error', 'i', { 'class': 'fa fa-check' })
          miniToastr.error(erro.body.msg, 'Alerta!', 7000)
        }
        this.loading = false
      })
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style scoped>
.action {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/classificaRede/ClassificaRede.vue